import React from "react";
import { CalendarRange } from "lucide-react";
import { Seg, fmtDate } from "./biShared";

const PRESETS = [
  { value: "week", label: "Settimana" },
  { value: "month", label: "Mese corrente" },
  { value: "year", label: "Anno" },
  { value: "custom", label: "Da – a" },
];
const GRAN = [{ value: "auto", label: "Auto" }, { value: "day", label: "Giorno" }, { value: "week", label: "Settimana" }, { value: "month", label: "Mese" }];

export default function BiFilters({ filters, onChange, period, showGranularity = true }) {
  const set = (patch) => onChange({ ...filters, ...patch });
  return (
    <div className="space-y-3" data-testid="bi-filters">
      <div className="flex flex-col lg:flex-row lg:items-center gap-3">
        <Seg options={PRESETS} value={filters.preset} onChange={(v) => set({ preset: v })} testIdPrefix="bi-preset" wrap />
        {filters.preset === "custom" && (
          <div className="flex items-center gap-2 flex-wrap">
            <input type="date" value={filters.date_from} onChange={(e) => set({ date_from: e.target.value })} className="h-11 px-3 rounded-xl border border-stone-300 bg-white text-sm" data-testid="bi-date-from" />
            <span className="text-stone-400 text-sm">→</span>
            <input type="date" value={filters.date_to} onChange={(e) => set({ date_to: e.target.value })} className="h-11 px-3 rounded-xl border border-stone-300 bg-white text-sm" data-testid="bi-date-to" />
          </div>
        )}
        {showGranularity && (
          <div className="lg:ml-auto flex items-center gap-2">
            <span className="text-xs text-stone-500 hidden sm:inline">Andamento per</span>
            <Seg options={GRAN} value={filters.granularity} onChange={(v) => set({ granularity: v })} testIdPrefix="bi-gran" size="sm" />
          </div>
        )}
      </div>
      {period && (
        <p className="text-xs text-stone-500 flex items-center gap-1.5" data-testid="bi-period-label">
          <CalendarRange className="w-3.5 h-3.5" /> Periodo <b className="text-stone-700">{fmtDate(period.from)} – {fmtDate(period.to)}</b> · confronto con <b className="text-stone-700">{fmtDate(period.prev_from)} – {fmtDate(period.prev_to)}</b>
        </p>
      )}
    </div>
  );
}
